var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExternalRequest = function SvgExternalRequest(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 20,
    viewBox: "0 0 19.4 19.4",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.227 13.684a.7.7 0 0 0 0 1.032l4.91 4.5a.7.7 0 1 0 .945-1.032L2.5 14.9h16.2a.7.7 0 1 0 0-1.4H2.5l3.582-3.284a.7.7 0 1 0-.946-1.032zm18.946-7.968a.7.7 0 0 0 0-1.032l-4.91-4.5a.7.7 0 1 0-.945 1.032L16.9 4.5H.7a.7.7 0 0 0 0 1.4h16.2l-3.582 3.284a.7.7 0 0 0 .946 1.032z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExternalRequest);
export default ForwardRef;